<script setup lang="ts"></script>

<template>
  <main class="main-content">
    <router-view />
  </main>
</template>

<style scoped lang="scss"></style>
